/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobLogResponse {
    getFixupPrototypeFunction() { return BackgroundJobLogResponse.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobLogResponse>): BackgroundJobLogResponse {
        let obj = Object.assign(new BackgroundJobLogResponse(), model);
        BackgroundJobLogResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobLogResponse>): BackgroundJobLogResponse {
        if (!model) return null;
        return BackgroundJobLogResponse.newInstance(<BackgroundJobLogResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobLogResponse) {
        if (!obj) return;

        models.BackgroundJobLogResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobLogResponse): boolean {
        Object.setPrototypeOf(obj, BackgroundJobLogResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.entries) {
            for (let val of this.entries) {
                models.BackgroundJobLog.fixupPrototype(val);
            }
        }
    }

    /**
     * Total number of log entries
     */
    count: number;

    /**
     * Requested log entries
     */
    entries: Array<models.BackgroundJobLog>;

}
